import React, { FC } from 'react'
import { AsH3, HeadingXS } from '@/atoms/Text'
import { Accordion, AccordionItem } from '@/molecules/Accordion'
import { Faq } from '@/types/codegen-federation'
import { useTranslate } from '@/utils/translate/translate-client'

interface ViewProps {
  faqs: Faq[]
  className?: string
}

export const TheatricalPifFaq: FC<ViewProps> = ({ className, faqs }) => {
  const { t } = useTranslate('pif')

  return (
    <div className={className}>
      <div className="border-b border-core-gray-300">
        <HeadingXS as={AsH3} className="mb-3 text-2xl tracking-tight text-core-gray-950" weight="bold">
          {t('frequentlyAskedQuestions', 'Frequently Asked Questions')}
        </HeadingXS>
        <Accordion>
          {faqs?.map((faq: Faq, index: number) => (
            <AccordionItem
              labelClassName="w-full text-lg font-bold text-2xl !leading-[1.25] font-whitney m-0 p-0 -tracking-[0.01em]"
              showTopBorder
              label={faq.question}
              key={faq.question}
              borderColor="core-gray-300"
              contentClassName="text-core-gray-700 !photon-paragraph-md !leading-7"
              defaultOpen={index === 0}
            >
              <div dangerouslySetInnerHTML={{ __html: faq.answer as string }} />
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  )
}
